import { call, put } from 'redux-saga/effects';
import {
    requestGetBillingEmployees,
    requestUpdateEmployeeSalaryData,
    requestSetEmployeeTerminated,
    requestGetEmployeePayments,
    requestCreateEmployeePayment,
    requestUpdateEmployeePayment,
    requestDeleteEmployeePayment
} from '../requests/billingEmployees';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetBillingEmployees(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetBillingEmployees);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) action.payload.callback(null);
    }
}

export function* handleUpdateEmployeeSalaryData(action) {
    try {
        const { employeeId, salaryData, callback } = action.payload;
        const response = yield call(requestUpdateEmployeeSalaryData, employeeId, salaryData);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}

export function* handleSetEmployeeTerminated(action) {
    try {
        const { employeeId, terminatedAt, callback } = action.payload;
        const response = yield call(requestSetEmployeeTerminated, employeeId, terminatedAt);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}

export function* handleGetEmployeePayments(action) {
    try {
        const { employeeId, callback } = action.payload;
        const response = yield call(requestGetEmployeePayments, employeeId);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}

export function* handleCreateEmployeePayment(action) {
    try {
        const { employeeId, payment, callback } = action.payload;
        const response = yield call(requestCreateEmployeePayment, employeeId, payment);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}

export function* handleUpdateEmployeePayment(action) {
    try {
        const { employeeId, paymentId, payment, callback } = action.payload;
        const response = yield call(requestUpdateEmployeePayment, employeeId, paymentId, payment);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}

export function* handleDeleteEmployeePayment(action) {
    try {
        const { employeeId, paymentId, callback } = action.payload;
        yield call(requestDeleteEmployeePayment, employeeId, paymentId);
        if (callback) callback({ ok: true });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}
